<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.5528 5.39454C11.0467 5.64153 11.6474 5.44131 11.8944 4.94733C12.1414 4.45335 11.9412 3.85268 11.4472 3.60569L6.44719 1.10569L5.99997 0.88208L5.55276 1.10569L0.552762 3.60569C0.0587832 3.85268 -0.141442 4.45335 0.105548 4.94733C0.352537 5.44131 0.95321 5.64153 1.44719 5.39454L5.99997 3.11815L10.5528 5.39454ZM10.5528 9.89454C11.0467 10.1415 11.6474 9.94131 11.8944 9.44733C12.1414 8.95335 11.9412 8.35268 11.4472 8.10569L6.44719 5.60569L5.99997 5.38208L5.55276 5.60569L0.552762 8.10569C0.0587832 8.35268 -0.141442 8.95335 0.105548 9.44733C0.352537 9.94131 0.95321 10.1415 1.44719 9.89454L5.99997 7.61815L10.5528 9.89454Z"
    fill="currentColor"
  />
</template>
